import { dispatchPageviewEvent } from './dispatchPageviewEvent';
import { handleRomanticVideoSliderClick } from './dispatchVideoClickEvent';
import { initPromoCheckoutAnalyticObserver } from './initPromoCheckoutAnalyticObserver';

export const dispatchBR1173Events = () => {
    dispatchPageviewEvent();
    initPromoCheckoutAnalyticObserver();
    handleRomanticVideoSliderClick();
};
